var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCampaignIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 13,
  fill: "none",
  viewBox: "0 0 14 13"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 6a3.003 3.003 0 0 1 3-3h2.488c.181-.011 3.35-.235 6.369-2.766A1 1 0 0 1 13.5 1v10a1 1 0 0 1-1.643.766C9.497 9.785 7.044 9.217 6 9.059v1.982a1 1 0 0 1-.445.833l-.687.458a1 1 0 0 1-1.524-.583l-.736-2.772A3.004 3.004 0 0 1 0 5.999m12.5 4.995V.999C9.824 3.244 7.086 3.812 6 3.952v4.092c1.084.143 3.823.71 6.5 2.95m-8.187.5v.007L5 11.044V8.999H3.65zM3 7.999h2V4H3a2 2 0 1 0 0 4"
})));
export { SvgCampaignIcon as ReactComponent };
export default __webpack_public_path__ + "4341d8b82d2c478954b66b4a58287439.svg";